import { Global } from '@emotion/react'

const Fonts = () => (
    <Global
        styles={`
        /* latin */
      @font-face {
        font-family: 'Katwijk-Black';
        src: url('/fonts/KatwijkMono-Black.woff2') format('woff2'),
            url('/fonts/KatwijkMono-Black.woff') format('woff');
        font-weight: 800;
        font-style: normal;
        font-display: swap;
    }
    /* latin */
    @font-face {
        font-family: 'Katwijk-Light';
        src: url('/fonts/KatwijkMono-Light.woff2') format('woff2'),
            url('/fonts/KatwijkMono-Light.woff') format('woff');
        font-weight: 300;
        font-style: normal;
        font-display: swap;
    }
    /* latin */
    @font-face {
        font-family: 'Katwijk-Bold';
        src: url('/fonts/KatwijkMono-Bold.woff2') format('woff2'),
            url('/fonts/KatwijkMono-Bold.woff') format('woff');
        font-weight: bold;
        font-style: normal;
        font-display: swap;
    }
    /* latin */
    @font-face {
        font-family: 'Katwijk-Regular';
        src: url('/fonts/KatwijkMono-Regular.woff2') format('woff2'),
            url('/fonts/KatwijkMono-Regular.woff') format('woff');
        font-weight: normal;
        font-style: normal;
        font-display: swap;
    }
        @font-face {
    font-family: 'NeueHaas-Medium';
    src: url('/fonts/NeueHaasDisplay-Mediu.woff2') format('woff2'),
        url('/fonts/NeueHaasDisplay-Mediu.woff') format('woff');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'NeueHaas-Roman';
    src: url('/fonts/NeueHaasDisplay-Roman.woff2') format('woff2'),
        url('/fonts/NeueHaasDisplay-Roman.woff') format('woff');
    font-weight: 500;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'NeueHaas-Light';
    src: url('/fonts/NeueHaasDisplay-Light.woff2') format('woff2'),
        url('/fonts/NeueHaasDisplay-Light.woff') format('woff');
    font-weight: 300;
    font-style: normal;
    font-display: swap;
}


        
      `}
    />
)

export default Fonts